import React, { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Package } from 'lucide-react';
import { invPhoto, checkPhoto, uploadInventoryPhoto } from './photos';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ItemPhotoPanel({ kind, item, headers, onChanged }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [broken, setBroken] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = '';
    if (!f) return;
    const err = checkPhoto(f);
    if (err) return toast.error(err);
    setBusy(true);
    try { await uploadInventoryPhoto(kind, item.id, f, headers); setBroken(false); toast.success('Photo saved'); onChanged(); }
    catch (x) { toast.error(x.response?.data?.detail || 'Upload failed'); } finally { setBusy(false); }
  };
  const remove = async () => {
    if (!window.confirm('Remove this photo from the item?')) return;
    setBusy(true);
    try { await axios.delete(`${API_URL}/api/admin/inventory/${kind}/${item.id}/photo`, { headers }); toast.success('Photo removed'); onChanged(); }
    catch { toast.error('Could not remove the photo'); } finally { setBusy(false); }
  };
  return (
    <section className="rounded-[10px] border border-[#e7e4db] bg-[#fffefa] overflow-hidden" data-testid="item-photo-panel">
      <div className="bg-[#f4f2ed] aspect-square max-h-[360px] w-full grid place-items-center p-5">
        {item.photo_url && !broken ? <img src={invPhoto(item.photo_url)} alt={item.name} className="max-h-full max-w-full object-contain" onError={() => setBroken(true)} data-testid="item-photo" />
          : <div className="text-center text-xs text-[#8a8c80]"><Package className="w-10 h-10 mx-auto text-[#c9c6b9] mb-2" />{broken ? 'This image could not be loaded.' : 'No photo yet'}</div>}
      </div>
      <div className="p-3 flex gap-2">
        <button onClick={() => input.current?.click()} disabled={busy} className="flex-1 text-xs border border-[#dcded2] rounded-md py-2 inline-flex justify-center items-center gap-1.5" data-testid="item-photo-change">{busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}{item.photo_url ? 'Change photo' : 'Upload photo'}</button>
        {item.photo_url && <button onClick={remove} disabled={busy} className="text-xs text-[#a4471b] px-3" data-testid="item-photo-remove">Remove</button>}
        <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} data-testid="item-photo-input" />
      </div>
      <p className="px-3 pb-3 text-[10px] text-[#8a8c80]">JPG, PNG or WebP up to 5 MB. Shown whole, never cropped.</p>
    </section>
  );
}
